export enum MainRoutes {
  ANY = "*",
  LOGIN = "login",
  PORTAL = "portal",
  PRODUCTION = 'production'
}
